module.exports = __webpack_public_path__ + "static/media/Graphics_8.e1b4b562.png";